<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('addCategory') }}</h2>
    <FormCategory @submit-requested="submitRequested"></FormCategory>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import FormCategory from '../forms/FormCategory.vue'

  export default {
  components: { FormCategory },
  methods: {
    ...mapActions('categories', ['addCategory']),
    submitRequested (categoriesInfo) {
      this.addCategory(categoriesInfo);
    },
  }

  }
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 